import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #ffffff;
`
const st1 = css`
  fill: #c9cfd3;
`
const st2 = css`
  fill: #eadcd5;
`
const st3 = css`
  fill: #fff5e3;
`
const st4 = css`
  fill: #475b69;
`
const st5 = css`
  fill: #273e4f;
`
class ReferFriend extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path
          css={st0}
          d='M26.3,35.1l6,2.7L17.4,68.6l-8.5-3.7L26.3,35.1z M73.3,35.1l-6,2.7l14.8,30.8l8.5-3.7L73.3,35.1z'
        />
        <path css={st1} d='M0,62.9l8,3.8l18.4-35.5L0,17.7L0,62.9z' />
        <path
          css={st2}
          d='M37.8,42.1l10.2-1l0.7,2.7L41,46.6l-3.5,11.7c6.6,3.6,11.3-5.3,15.3-5.9c1.9-0.3,6.6,4.2,6.6,4.2l12.1,14.4 l-14,10.4l-6.8,2.2l-3.5-2.2l-2.7-5.8l-2.4-6.4h-3l-2.8-3.3l-5.6,1.9L21,61.1l9.9-20.8L37.8,42.1z'
        />
        <path
          css={st3}
          d='M29.7,67.8l6.1-1.1l4.7,1.9l3.1,2.5l2.9,4.4l0.8,3.8l-1.9,4.3L32.4,77L29,72.4l-4.7-3.8l2-3.7L29.7,67.8z M56.7,40.3l-6.7,3l-8.4,2.8c0,0-3.7,11.9-1.9,13.2c1.8,1.3,6.8-3.9,6.8-3.9s4.2-4.8,9.3-2.5s14.9,15.8,14.9,15.8l9.1-3.5L69.1,42.1 C62.8,43.5,56.7,40.3,56.7,40.3z'
        />
        <path
          css={st4}
          d='M100,62.9l-8,3.8L73.6,31.2c0,0,25.6-13.2,26.4-13.5V62.9z'
        />
        <path
          css={st5}
          d='M100,14.9L71.5,30.1c-0.4,0.2-0.7,0.6-0.9,1.1c-0.1,0.5-0.1,0.9,0.2,1.3l0.4,0.8L66,35.8 c-0.4,0.2-0.7,0.6-0.9,1c-0.1,0.4-0.1,0.9,0.1,1.3l1.3,2.7c-0.3,0.1-0.7,0.1-1.3,0.1c-0.8-0.1-2-0.5-3.2-0.9c-2.2-0.8-4.6-1.6-7-1.3 c-1.6,0.2-3,0.9-4.4,1.7c-2.9-2.4-8.3-1.7-10.9-0.9c-1.4,0.4-3.8,0.4-5.8,0.2l0.8-1.6c0.2-0.4,0.2-0.9,0.1-1.3 c-0.1-0.4-0.5-0.8-0.9-1l-5.3-2.6l0.4-0.8c0.2-0.4,0.3-0.9,0.2-1.3s-0.4-0.8-0.9-1.1L0,14.9v4l25.3,13.4L7.5,64.1 c-0.1,0.1-0.2,0.2-0.3,0.3L0,61v3.9l7.3,3.4c0.2,0.1,0.5,0.2,0.7,0.2c0.5,0,1.1-0.3,1.4-0.7l7.3,3c0.2,0.1,0.4,0.1,0.7,0.1 c0.6,0,1.3-0.4,1.6-1l2.6-5.2l1.4,0.9c0,0,0,0,0,0c-0.1,0.3-0.9,2.9,0.5,5.2c0.6,0.9,1.7,2.1,3.9,2.7c0.4,3.2,3.6,4.4,6,4.7 c1,2.2,3.3,3.2,5,3.5c0.1,0.3,0.3,0.6,0.5,0.9c1.7,2.1,3.7,2.7,5.5,2.7c1.4,0,2.6-0.4,3.3-0.8c0.1-0.1,0.2-0.1,0.3-0.2 c1.3,0.7,2.9,1.1,4.7,0.7c1.7-0.4,2.7-1.3,3.4-2.1c0.2,0,0.4,0.1,0.7,0.1c0.4,0,0.9-0.1,1.3-0.2c1.8-0.6,2.9-2.4,3.5-3.7 c0.2,0,0.5,0,0.7,0c0.9,0,1.8-0.2,2.6-0.9c1-0.7,1.6-1.6,1.9-2.3c0.3,0,0.6,0.1,0.8,0.1c1.1,0,2.3-0.4,3.4-1.3 c1.9-1.6,2.2-3.2,2-4.6l6.3-3.2l1.6,3.1c0.3,0.6,0.9,1,1.6,1c0.2,0,0.4,0,0.7-0.1l7.3-3c0.3,0.5,0.9,0.7,1.4,0.7 c0.2,0,0.5-0.1,0.7-0.2l7.3-3.4V61l-7.2,3.3c-0.1-0.1-0.2-0.2-0.3-0.3L74.7,32.3L100,18.9V14.9z M16.6,66.8l-5.4-2.2L27,36.3 l3.8,1.9L16.6,66.8z M27.9,69.9c-0.6-0.2-1.1-0.5-1.3-0.9c-0.3-0.5-0.3-1.1-0.3-1.6l2.2,1.3C28.2,69.1,28,69.5,27.9,69.9z M33.1,74.4c-1-0.2-2.2-0.7-2.3-1.6c-0.2-2.4,2.1-4.5,3.4-4.9c0.4-0.1,1.4-0.2,1.9,0.1c0.3,0.2,0.3,0.6,0.4,1 c-0.2,0.2-0.4,0.4-0.5,0.5C34.8,70.7,33.6,72.5,33.1,74.4z M39.9,76c-0.6,0.6-1,1.3-1.3,2c-0.8-0.2-2.1-0.7-2.2-1.9 c-0.1-1,0.6-2.6,1.8-3.9c1-1.2,2-1.7,2.3-1.7c0.6,0,1.4,0.3,1.6,0.8c0.1,0.3,0.4,1.4-1.4,3.8C40.5,75.4,40.2,75.7,39.9,76z M45.4,81.5c-0.9,0.2-2.4,0.3-3.7-1.3c-0.1-0.3,0.4-1.6,1.6-2.6c0,0,0,0,0,0c0,0,0,0,0,0c0.6-0.5,1.1-0.6,1.3-0.6c0.1,0,0.1,0,0.1,0 c1.2,0.7,0.5,3,0.5,3.1C45,80.5,45.1,81.1,45.4,81.5z M68.8,71.8c-2.1,1.8-5.6-1.9-9.9-6.9c-0.6-0.7-1.7-0.8-2.5-0.2 c-0.7,0.6-0.8,1.7-0.2,2.5c2.2,2.6,4.8,5.5,7.3,7.2c-0.1,0.3-0.4,0.6-0.8,0.8c-0.9,0.6-2.5-0.7-2.8-0.9l-3.6-3.8 c-0.7-0.7-1.8-0.7-2.5-0.1c-0.7,0.7-0.7,1.8-0.1,2.5l3.7,3.9c0.2,0.2,0.5,0.4,0.7,0.6c-0.4,0.8-1,1.6-1.4,1.7 c-0.9,0.3-2.2-0.9-2.7-1.5l-2.9-4.2c-0.5-0.8-1.6-1-2.4-0.5c-0.8,0.5-1,1.6-0.5,2.4l2.9,4.3c0,0,0.1,0.1,0.1,0.1 c0.1,0.1,0.5,0.6,1.2,1.2c-0.2,0.1-0.5,0.3-0.9,0.3c-1.5,0.4-2.6-0.5-3.1-1.1c0.4-1.9,0.2-4.8-2.3-6.2c-0.3-0.2-0.7-0.3-1-0.4 c0.4-1.4,0.4-2.7-0.1-3.8c-0.9-2-3-2.7-4.6-2.8c-0.4,0-0.7,0-1.1,0.1c-0.3-0.9-0.9-1.5-1.4-1.9c-1.7-1.3-4-1-5.1-0.6 c-0.8,0.3-1.6,0.8-2.4,1.4l-7.5-4.6l9.2-18.3c2,0.2,5.9,0.6,8.5-0.2c2.1-0.7,4.8-0.8,6.5-0.3c-0.6,0.4-1.1,0.7-1.5,0.9 c-0.5,0.2-1.2,0.3-2,0.4c-1.6,0.2-3.8,0.5-4.8,2.8c-1,2.2-2.9,10.1-3.1,11c-0.2,0.7,0.1,1.4,0.7,1.8c0.3,0.2,2.8,1.9,5.9,1.4 c2-0.4,3.6-1.5,5-3.5c2.2-3.3,4.5-3.6,5.2-3.6c1.1,0.8,4.7,3.3,8.1,6.3c0.2,0.2,0.4,0.4,0.7,0.6c2.5,2.2,5,4.6,6.2,6.7 c0.2,0.3,0.5,0.7,0.8,1C70,70.2,70.1,70.8,68.8,71.8z M71.6,66.7c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.4-0.5-0.5-0.6 c-0.9-1.5-2.3-3.1-3.9-4.7c0.5-0.1,1-0.3,1.6-0.6c0.8-0.5,1.1-1.6,0.6-2.4c-0.5-0.8-1.6-1.1-2.4-0.6c-1,0.6-2.5,0.5-3.4,0.3 c-4.3-3.7-8.6-6.6-8.9-6.8c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2,0-5-1-9.1,5.1c-0.8,1.1-1.7,1.8-2.7,2c-0.8,0.2-1.6,0-2.2-0.3 c0.7-2.9,2-7.8,2.6-9.1c0.2-0.4,0.7-0.5,2.1-0.7c0.9-0.1,1.9-0.3,2.9-0.7c0.9-0.4,1.8-1,2.8-1.7c1.7-1.2,3.6-2.5,5.4-2.7 c1.6-0.2,3.5,0.5,5.4,1.1c1.5,0.5,2.8,1,4.1,1.1c1.4,0.1,2.4-0.1,3.1-0.4l9.8,19.5L71.6,66.7z M88.8,64.6l-5.4,2.2L69.1,38.2 l3.8-1.9L88.8,64.6z'
        />
      </svg>
    )
  }
}

ReferFriend.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { ReferFriend }
